import React, { useContext } from 'react';

const ContentCardContext = React.createContext();

export function useContentCard() {
  const context = useContext(ContentCardContext);
  if (!context) {
    throw new Error(`useContentCard must be used within a Provider`);
  }

  return {
    isPwrCard: context === 'pwr',
    isClientCard: context === 'client',
  };
}

export function PwrContentCardProvider(props) {
  return <ContentCardContext.Provider value={'pwr'} {...props} />;
}

export function ClientContentCardProvider(props) {
  return <ContentCardContext.Provider value={'client'} {...props} />;
}



// WEBPACK FOOTER //
// ./src/context/content-card-context.js